// import './InputField.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { KEYBOARD } from '../../constants';

/**
 * InputField Component
 * @augments {Component<Props, State>}
 */
class InputField extends Component {

    _isValid = () => {
        const { value, isValid, pattern } = this.props;
        let valid = true;

        if (isValid !== undefined || pattern !== undefined) {
            valid = isValid === true || pattern && new RegExp(pattern).test(value);
        }

        return valid;
    }

    _handleSubmit = (e) => {
        const { onSubmit, disabled } = this.props;
        if (onSubmit && this._isValid() && !disabled) {
            onSubmit(e);
        }
    }

    _checkForKey = (e) => {
        const { onSubmit, submitKeys } = this.props;

        if (onSubmit && submitKeys.indexOf(e.keyCode) >= 0) {
            e.preventDefault();
            this._handleSubmit(e);
        }
    }

    render() {
        const { onChange, value, type, disabled, onBlur } = this.props;
        return (
            <input className={'InputField'} onKeyDown={this._checkForKey} onBlur={onBlur} onChange={onChange} value={value} type={type} disabled={disabled} />
        );
    }
}

InputField.defaultProps = {
    isValid: true,
    pattern: null,
    type: 'text',
    onSubmit: null,
    onBlur: null,
    disabled: false,
    submitKeys: [KEYBOARD.ENTER, KEYBOARD.TAB],
};

InputField.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,

    isValid: PropTypes.bool,
    pattern: PropTypes.string,
    type: PropTypes.string,
    onSubmit: PropTypes.func,
    disabled: PropTypes.bool,
    submitKeys: PropTypes.array,
};

export default InputField;
